<template>
      <version :isEdit="true"></version>

</template>

<script>
    import version from '@/components/page/fota/Version'
    export default {
        name: 'versionHomeUpdate',
        components: {version} 
    }   
</script>

<style></style>